import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '../services/state.service';
import { ApiService } from '../services/api.service';
import { VehicleService } from '../services/vehicle.service';
import { GoogleMapService } from '../services/google-map.service';
import * as moment from 'moment';
import { Options, ChangeContext } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-trip',
  templateUrl: './trip.component.html',
  styleUrls: ['./trip.component.css']
})
export class TripComponent implements OnInit {

  constructor(private stateSvc: StateService, private vehicleSvc: VehicleService, private apiSvc: ApiService, private gmapSvc: GoogleMapService) {
	  this.callback_fc = this.callback_fc.bind(this);
  }

  listedVehicles = [];
  events:any = [];
  tripMarkers:any = [];
  pathCoords = [];
  map:any = {};
  activeSelectedVhcl:any = {};
  vehicleMarker:any = {};
  startEndFlagMarker:any = [];
  tripInfowindow:any = [];
  vehicleSubs:any;
  mapInsSubs:any;
  tripPath:any = [];
  
  currentDate = moment();
  currentDateStr = "";
  hasTomorrow = false;
  showControls = true;
  playback = {
	playing: false,
	step: 0,
	steps: 0,
  };
  timeout:any = false;
  
  minValue = 0;
  maxValue = 24;
  options: Options = {
    floor: 0,
    ceil: 24,
	step: 1,
	noSwitching: true,
	showTicks: true,
    showTicksValues: true,
	getPointerColor: (value: number): string => {
		return 'black'
	}
  };
  storedDirectionsService:any = {};
  storedDirectionsRenderer:any = {};
  globalProvider:any = "OpenStreetMap";

  currentPoint:any = {};
  
  ngOnInit(): void {
	this.globalProvider = this.stateSvc.getMapType();
	let currentMapProvider = this.stateSvc.getMapType();
	this.minValue = this.vehicleSvc.getRangeTrips()[0];
	this.maxValue = this.vehicleSvc.getRangeTrips()[1];
	this.vehicleSvc.clearAllLocalVehicleOnMap();
	if(currentMapProvider == "Google"){
		this.storedDirectionsService = new google.maps.DirectionsService();
		this.storedDirectionsRenderer = new google.maps.DirectionsRenderer({
			suppressMarkers: true,
			preserveViewport: true
		});
	}

	this.stateSvc.setShowMultipleOnMap(false);
	this.stateSvc.setShowControl(true);
	this.vehicleSubs = this.stateSvc.vehicles
	.subscribe((result) => {
		this.listedVehicles = result;
		let ifHaveSelected = false;
		if(this.listedVehicles.length > 0){
			this.listedVehicles.forEach((flterdVhcl) => {
				if(flterdVhcl.shownOnMap){
					ifHaveSelected = true;
					if(flterdVhcl.unitid != this.activeSelectedVhcl.unitid){
						this.activeSelectedVhcl = flterdVhcl;
						this.fetchMovementEvents();
					}
					return;
				}
			});
		}
		if(!ifHaveSelected){
			this.activeSelectedVhcl = {};
			this.removeTripMarker();
		}
	});
	this.mapInsSubs = this.stateSvc.mapInstance
	.subscribe((map) => {
		this.map = map;
		if(currentMapProvider == "Google"){
			if(this.map?.mapTypeId){
				this.storedDirectionsRenderer.setMap(this.map);
			}
		}
	});
	this.updateDateStr();
  }
  
  callback_fc(response, status){
	if (status != 'OK') {
		//console.log('Directions request failed due to ' + status);
		return;
	}
	//var renderer = new google.maps.DirectionsRenderer;
	if(this.map?.mapTypeId){
		this.storedDirectionsRenderer.setMap(this.map);
	}
	this.storedDirectionsRenderer.setOptions({ suppressMarkers: true, preserveViewport: true });
	this.storedDirectionsRenderer.setDirections(response);
	//console.log(response)
  }
  
  ngOnDestroy(){
	let currentMapProvider = this.stateSvc.getMapType();
	this.tripMarkers = [];
	// vehicle marker
	if(currentMapProvider == "Google"){
		if(this.vehicleMarker?.map){
			this.vehicleMarker.setMap(null);
		}
	}else{
		if(this.vehicleMarker?._latlng){
			this.vehicleMarker.remove();
		}
	}
	this.vehicleMarker = {};
	// start end flag marker
	if(this.startEndFlagMarker.length > 0){
		this.startEndFlagMarker.forEach((mkr) => {
			if(currentMapProvider == "Google"){
				mkr.setMap(null);
			}else{
				mkr.remove();
			}
		});
	}
	if(this.tripPath.length > 0){
		this.tripPath.forEach((path) => {
			if(currentMapProvider == "Google"){
				path.setMap(null);
			}else{
				path.remove();
			}
		});
		this.tripPath = [];
	}
	this.startEndFlagMarker = [];
	this.stateSvc.setTripMarkers(this.tripMarkers);
	if(currentMapProvider == "Google"){
		this.storedDirectionsRenderer.setDirections({routes: []});
		this.storedDirectionsRenderer.setMap(null);
	}
	this.vehicleSubs.unsubscribe();
	this.mapInsSubs.unsubscribe();
   }
  
  fetchMovementEvents(){
	let userObj = this.stateSvc.getLocalSession();
	this.removeTripMarker();
	this.playback.step = 0;
	this.events = [];
	let tempStt = this.minValue < 10? '0'+this.minValue : this.minValue;
	let tempEnd = this.maxValue < 10? '0'+this.maxValue : this.maxValue;
	if(tempEnd == 24){
		tempEnd = 23;
	}
	let startStr = tempStt + ':00:00';
	let endStr = tempEnd + ':59:59';
	let startDate = this.currentDate.format('YYYY-MM-DD ' + startStr);
	let endDate = this.currentDate.format('YYYY-MM-DD ' + endStr);
	let currentMapProvider = this.stateSvc.getMapType();
	if(userObj.source == "oncore"){
		this.vehicleSvc.getMobileEvent(this.activeSelectedVhcl.unitid,startDate,endDate)
		.subscribe((events) => {
			this.events.splice(0, this.events.length);
			this.events = events;
			if(currentMapProvider == "Google"){
				this.storedDirectionsRenderer.setMap(null);
				if(events.length > 0 && this.map?.mapTypeId){
					this.storedDirectionsRenderer.setMap(this.map);
					this.drawTrip(events,this.activeSelectedVhcl);
					this.playback.steps = events.length - 1;
					this.playback.step = 0;
				}
			}else{
				if(events.length > 0 && this.map){
					this.drawTrip(events,this.activeSelectedVhcl);
					this.playback.steps = events.length - 1;
					this.playback.step = 0;
				}
			}
		});
	}else if(userObj.source == "bsj"){
		this.vehicleSvc.getVehicleTracks(this.activeSelectedVhcl.terminalNo,startDate,endDate)
		.subscribe((events:any) => {
			this.events.splice(0, this.events.length);
			this.events = events;
			if(currentMapProvider == "Google"){
				this.storedDirectionsRenderer.setMap(null);
				if(events.length > 0 && this.map?.mapTypeId){
					this.storedDirectionsRenderer.setMap(this.map);
					this.drawTrip(events,this.activeSelectedVhcl);
					this.playback.steps = events.length - 1;
					this.playback.step = 0;
				}
			}else{
				if(events.length > 0 && this.map){
					this.drawTrip(events,this.activeSelectedVhcl);
					this.playback.steps = events.length - 1;
					this.playback.step = 0;
				}
			}
		})
	}else{
		let localStartDate = new Date(startDate);
		let localEndDate = new Date(endDate);
		localStartDate.setTime(localStartDate.getTime() - 28800000);
		localEndDate.setTime(localEndDate.getTime() - 28800000);
		this.vehicleSvc.getVehicleTripTracksolid(this.activeSelectedVhcl.unitid,moment(localStartDate).format("YYYY-MM-DD HH:mm:ss"),moment(localEndDate).format("YYYY-MM-DD HH:mm:ss"))
		.subscribe((events:any) => {
			this.events.splice(0, this.events.length);
			this.events = events;
			if(events?.length > 0){
				this.events.forEach((event) => {
					event.lon = event.lng;
					if(!event.event){
						event.event = 'time';
					}
					if(event.direction){
						event.bearing = event.direction;
					}
					if(!event.location){
						event.location = event.lat + ',' + event.lon;
					}
					if(event.gpsSpeed){
						event.speed = event.gpsSpeed;
					}
					const dateStr = event.devTime || event.gpsTime;
					// Convert to ISO format (important)
					const date = new Date(dateStr.replace(' ', 'T') + '+00:00');
					// Get milliseconds
					const timestamp = date.getTime();
					// Build .NET format
					const dotNetDate = "/Date(" + timestamp + "+0800)/";
					event.updated = moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x');
				});
			}
			if(currentMapProvider == "Google"){
				this.storedDirectionsRenderer.setMap(null);
				if(events.length > 0 && this.map?.mapTypeId){
					this.storedDirectionsRenderer.setMap(this.map);
					this.drawTrip(events,this.activeSelectedVhcl);
					this.playback.steps = events.length - 1;
					this.playback.step = 0;
				}
			}else{
				if(events.length > 0 && this.map){
					this.drawTrip(events,this.activeSelectedVhcl);
					this.playback.steps = events.length - 1;
					this.playback.step = 0;
				}
			}
		})
	}
  }
  
  drawTrip(events, vhcInfo){
	let currentMapProvider = this.stateSvc.getMapType();
	this.tripMarkers = [];
	this.tripInfowindow = [];
	this.pathCoords = [];
	// vehicle marker
	if(currentMapProvider == "Google"){
		if(this.vehicleMarker?.map){
			this.vehicleMarker.setMap(null);
		}
	}else{
		if(this.vehicleMarker?._latlng){
			this.vehicleMarker.remove();
		}
	}
	
	this.vehicleMarker = {};
	// start end flag marker
	if(this.startEndFlagMarker.length > 0){
		this.startEndFlagMarker.forEach((mkr) => {
			if(currentMapProvider == "Google"){
				mkr.setMap(null);
			}else{
				mkr.remove();
			}
		});
	}
	if(this.tripPath.length > 0){
		this.tripPath.forEach((path) => {
			if(currentMapProvider == "Google"){
				path.setMap(null);
			}else{
				path.remove();
			}
		});
	}
	this.tripPath = [];
	this.startEndFlagMarker = [];
	let bounds:any = null;
	if(currentMapProvider == "Google"){
		bounds = new google.maps.LatLngBounds();
	}else{
		bounds = [];
	}
	let vehicleInfo = this.vehicleSvc.getVehicleInfo(this.listedVehicles, events[0].unitid);
	let iconbase = this.apiSvc.getIconbase();
	/*let waypts: google.maps.DirectionsWaypoint[] = [];
	let startCount = 1;
	let grp = [];*/
	let lastPart:any = [];
	let parts = {};
	let dvdr = 95;
	let eventLeng = events.length - 1;
	let adjustedLeng = eventLeng + Math.ceil(eventLeng / dvdr);
	for(let i = 0; i<= adjustedLeng; i++){
		let firstLyr = Math.floor(i / dvdr);
		let secondLyr = i % dvdr;
		let thirdLyr = Math.floor(i/dvdr);
		if(!parts[firstLyr]){
			parts[firstLyr] = [];
		}
		if(events[(i - thirdLyr)]){
			parts[firstLyr][secondLyr] = events[(i - thirdLyr)];
		}
	}
	
	this.pushToCoordsArray(events[0].lat, events[0].lon);

	let symbol = vhcInfo?.symboltype + 1;
	if (symbol < 10) {
		symbol = '0' + symbol;
	}
	let tempVhclMrkr:any = null;
	
	//events.forEach((event) => {
	for(let i in parts){
		//waypts = [];
		let objStops = parts[i];
		objStops.forEach((event, idx) => {
			if(!event.event){
				event.event = 'time';
			}
			if(event.direct){
				event.bearing = event.direct;
			}
			if(!event.location){
				event.location = event.lat + ',' + event.lon;
			}
			if(!event.updated && (event.devTime || event.gpsTime)){
				const dateStr = event.devTime || event.gpsTime;
				// Convert to ISO format (important)
				const date = new Date(dateStr.replace(' ', 'T') + '+08:00');
				// Get milliseconds
				const timestamp = date.getTime();
				// Build .NET format
				const dotNetDate = "/Date(" + timestamp + "+0800)/";
				event.updated = moment(dotNetDate.substr(6).substr(0, dotNetDate.indexOf('+') - 6), 'x');
			}
			let infowWindowContent = "<div class='vehicle--summary-header'><span class='vehicle--plate'>" + event.event.replace('_', ' ') + "</span></div>" +
				"<div><small class='text-muted'>" + event.updated.format('DD-MM-YYYY HH:mm:ss') + "</small></div>" +
				"<div>Speed: " + event.speed + "</div>" +
				"<div>Location: " + event.location + "</div>";

			let infoWindow:any;
			let marker:any;
			if(currentMapProvider == "Google"){
				let pos = new google.maps.LatLng({
					lat: event.lat,
					lng: event.lon
				});
				marker = new google.maps.Marker({
					position: pos,
					map: this.map,
					icon: {
						url: this.getMarkerImage(event),
						anchor: new google.maps.Point(10, 10),
					}
				});

				infoWindow = new google.maps.InfoWindow({
					content: infowWindowContent,
					pixelOffset: new google.maps.Size(0, -20)
				});

				marker.addListener('click', () => {
					if(!infoWindow?.getMap()){
						infoWindow.open(this.map, marker);
					}else{
						infoWindow.close();
					}
				});
				this.tripInfowindow.push(infoWindow);
				bounds.extend(pos);
			}else{
				let iconImgUrl = this.getMarkerImage(event);
				let anchorIcon = [16, 8];
				if(iconImgUrl == 'assets/images/events_icon/time_se.png' || iconImgUrl == 'assets/images/events_icon/time_nw.png'){
					anchorIcon = [14, 8];
				}else if(iconImgUrl == 'assets/images/events_icon/time_n.png'){
					anchorIcon = [10, 8];
				}else if(iconImgUrl == 'assets/images/events_icon/time_s.png' || iconImgUrl == 'assets/images/events_icon/time_ne.png'){
					anchorIcon = [12, 8];
				}
				let greenIcon = L.icon({
					iconUrl: iconImgUrl,
					iconAnchor: anchorIcon
				});
				marker = L.marker([event.lat, event.lon], {icon: greenIcon});
				marker.bindPopup(infowWindowContent);
				marker.addTo(this.map);
				this.tripInfowindow.push(marker);
				bounds.push([event.lat,event.lon]);
			}
			this.tripMarkers.push(marker);
			this.pushToCoordsArray(event.lat, event.lon);
			lastPart = [event.lat, event.lon];
		});
		this.callRoadApi();
		this.pathCoords = [];
	}
	this.pushToCoordsArray(lastPart[0], lastPart[1]);

	let markerStart:any = null;
	if(currentMapProvider == "Google"){
		markerStart = new google.maps.Marker({
			position: new google.maps.LatLng({
				lat: events[0].lat,
				lng: events[0].lon
			}),
			map: this.map,
			icon: 'assets/images/events_icon/start.png'
		});
	}else{
		let greenIcon = L.icon({
			iconUrl: 'assets/images/events_icon/start.png',
			iconAnchor: [12, 48]
		});
		markerStart = L.marker([events[0].lat,events[0].lon], {icon: greenIcon}).addTo(this.map);
	}
	this.startEndFlagMarker.push(markerStart);
	
	let markerEnd:any;
	if(currentMapProvider == "Google"){
		markerEnd = new google.maps.Marker({
			position: new google.maps.LatLng({
				lat: events[(events.length - 1)].lat,
				lng: events[(events.length - 1)].lon
			}),
			map: this.map,
			icon: 'assets/images/events_icon/end.png'
		});
	}else{
		let greenIcon = L.icon({
			iconUrl: 'assets/images/events_icon/end.png',
			iconAnchor: [12, 48]
		});
		markerEnd = L.marker([events[(events.length - 1)].lat, events[(events.length - 1)].lon],{icon: greenIcon});
		markerEnd.addTo(this.map);
	}
	this.startEndFlagMarker.push(markerEnd);
	this.pushToCoordsArray(events[(events.length - 1)].lat, events[(events.length - 1)].lon);

	if(currentMapProvider == "Google"){
		tempVhclMrkr = new google.maps.Marker({
			position: { lat: events[0].lat, lng: events[0].lon },
			map: this.map,
			icon: iconbase + symbol + '.png',
		});
	}else{
		let greenIcon = L.icon({
			iconUrl: iconbase + symbol + '.png',
			iconAnchor: [24, 24]
		});
		tempVhclMrkr = L.marker([events[0].lat,events[0].lon], {icon:greenIcon}).addTo(this.map);
		tempVhclMrkr.setZIndexOffset(1000);
	}
	this.vehicleMarker = tempVhclMrkr;
	
	this.callRoadApi();
	
	/*let startPart = 1;
	for(let i in parts){
		waypts = [];
		let objStops = parts[i];
		objStops.forEach((stp, idx) => {
			let vehicleInfo = this.vehicleSvc.getVehicleInfo(this.listedVehicles, stp.unitid);
			if(idx > 0 && idx < (objStops.length - 1)){
				waypts.push({
					location: new google.maps.LatLng(stp.lat, stp.lon),
					stopover: true,
				  });
			  const mrkr = new google.maps.Marker({
				position: { lat: stp.lat, lng: stp.lon },
				map: this.map,
				icon: {
					url: this.getMarkerImage(stp),
					anchor: new google.maps.Point(10, 10),
				}
			  });
			  let infowWindowContent = "<div class='vehicle--summary-header'><span class='vehicle--plate'>" + stp.event.replace('_', ' ') + "</span></div>" +
                    "<div><small class='text-muted'>" + stp.updated.format('DD-MM-YYYY HH:mm:ss') + "</small></div>" +
                    "<div>Speed: " + stp.speed + "</div>" +
                    "<div>Location: " + stp.location + "</div>";
                let infoWindow:any = new google.maps.InfoWindow({
					content: infowWindowContent,
                  pixelOffset: new google.maps.Size(0, -20)
                });
				this.tripInfowindow.push(infoWindow);
                mrkr.addListener('click', () => {
					if(!infoWindow?.getMap()){
						infoWindow.open(this.map, mrkr);
					}else{
						infoWindow.close();
					}
                });
			  this.tripMarkers.push(mrkr);
			}else{
				let iconImg = '';
				let notStartEnd = true;
				if(i == '0' && idx == 0){
					iconImg = "assets/images/events_icon/start.png";
					let symbol = vehicleInfo.symboltype + 1;
					if (symbol < 10) {
						symbol = '0' + symbol;
					}
					let tempVhclMrkr:any = new google.maps.Marker({
						position: { lat: stp.lat, lng: stp.lon },
						map: this.map,
						icon: iconbase + symbol + '.png',
					  });
					this.vehicleMarker = tempVhclMrkr;
					const duplmrkr = new google.maps.Marker({
						position: { lat: stp.lat, lng: stp.lon },
						map: this.map,
						icon: {
							url: this.getMarkerImage(stp),
							anchor: new google.maps.Point(10, 10),
						}
					  });
					this.tripMarkers.push(duplmrkr);
					let infowWindowContent = "<div class='vehicle--summary-header'><span class='vehicle--plate'>" + stp.event.replace('_', ' ') + "</span></div>" +
						"<div><small class='text-muted'>" + stp.updated.format('DD-MM-YYYY HH:mm:ss') + "</small></div>" +
						"<div>Speed: " + stp.speed + "</div>" +
						"<div>Location: " + stp.location + "</div>";
					let infoWindow:any = new google.maps.InfoWindow({
						content: infowWindowContent,
					  pixelOffset: new google.maps.Size(0, -20)
					});
					this.tripInfowindow.push(infoWindow);
					duplmrkr.addListener('click', () => {
						if(!infoWindow?.getMap()){
							infoWindow.open(this.map, duplmrkr);
						}else{
							infoWindow.close();
						}
					});
					notStartEnd = false;
				}else if(idx > 0 && startPart == Object.keys(parts).length){
					iconImg = "assets/images/events_icon/end.png";
					notStartEnd = false;
					const duplmrkr = new google.maps.Marker({
						position: { lat: stp.lat, lng: stp.lon },
						map: this.map,
						icon: {
							url: this.getMarkerImage(stp),
							anchor: new google.maps.Point(10, 10),
						}
					  });
					this.tripMarkers.push(duplmrkr);
					let infowWindowContent = "<div class='vehicle--summary-header'><span class='vehicle--plate'>" + stp.event.replace('_', ' ') + "</span></div>" +
						"<div><small class='text-muted'>" + stp.updated.format('DD-MM-YYYY HH:mm:ss') + "</small></div>" +
						"<div>Speed: " + stp.speed + "</div>" +
						"<div>Location: " + stp.location + "</div>";
					let infoWindow:any = new google.maps.InfoWindow({
						content: infowWindowContent,
					  pixelOffset: new google.maps.Size(0, -20)
					});
					this.tripInfowindow.push(infoWindow);
					duplmrkr.addListener('click', () => {
						if(!infoWindow?.getMap()){
							infoWindow.open(this.map, duplmrkr);
						}else{
							infoWindow.close();
						}
					});
				}else{
					iconImg = this.getMarkerImage(stp);
				}
				const mrkr = new google.maps.Marker({
					position: { lat: stp.lat, lng: stp.lon },
					map: this.map,
					icon: iconImg,
				  });
				  if(notStartEnd){
					this.tripMarkers.push(mrkr);
					let infowWindowContent = "<div class='vehicle--summary-header'><span class='vehicle--plate'>" + stp.event.replace('_', ' ') + "</span></div>" +
						"<div><small class='text-muted'>" + stp.updated.format('DD-MM-YYYY HH:mm:ss') + "</small></div>" +
						"<div>Speed: " + stp.speed + "</div>" +
						"<div>Location: " + stp.location + "</div>";
					let infoWindow:any = new google.maps.InfoWindow({
						content: infowWindowContent,
					  pixelOffset: new google.maps.Size(0, -20)
					});
					this.tripInfowindow.push(infoWindow);
					mrkr.addListener('click', () => {
						if(!infoWindow?.getMap()){
							infoWindow.open(this.map, mrkr);
						}else{
							infoWindow.close();
						}
					});
				  }else{
					 this.startEndFlagMarker.push(mrkr);
				  }
			}
			bounds.extend({ lat: stp.lat, lng: stp.lon })
		});
		var svcReq = {
			origin: new google.maps.LatLng(objStops[0].lat, objStops[0].lon),
		  destination: new google.maps.LatLng(objStops[(objStops.length - 1)].lat, objStops[(objStops.length - 1)].lon),
		  waypoints: waypts,
		  optimizeWaypoints: true,
		  travelMode: google.maps.TravelMode.DRIVING,
		};
		this.storedDirectionsService
		.route(svcReq, (response, status) => {
			this.callback_fc(response, status);
			startPart++;
		})
	}*/
	const viewportWidth = window.innerWidth;
	console.log(viewportWidth);
	if(viewportWidth > 768){
		this.map.fitBounds(bounds,{
			paddingTopLeft: [0, 130],
			paddingBottomRight: [10, 10]
		});
	}else{
		this.map.fitBounds(bounds,{
			paddingTopLeft: [0, 10],
			paddingBottomRight: [10, 75]
		});
	}
  }
  
	prevDate() {
		this.currentDate = this.currentDate.subtract(1, 'day');
		this.currentDateChanged();
	}

	nextDate() {
		this.currentDate = this.currentDate.add(1, 'day');
		this.currentDateChanged();
	}
	
	currentDateChanged(){
		this.updateDateStr();
		this.fetchMovementEvents();
		if(this.currentDate.isSame(new Date(), "day")) {
			return this.hasTomorrow = false;
		}
		this.hasTomorrow = true;
	}

	goBack() {
		if(this.playback.step == 0) {
			return;
		}
		this.playback.step--;
		this.afterPlaybackChanged();
	}

	goFwd() {
		if(this.playback.step == this.playback.steps) {
			return false;
		}
		this.playback.step++;
		this.afterPlaybackChanged();
		return true;
	}
	
	goFastBack() {
		this.playback.step = 0;
		this.afterPlaybackChanged();
	}

	goFastFwd() {
		this.playback.step = this.playback.steps;
		this.afterPlaybackChanged();
	}
	
	afterPlaybackChanged(){
		let currentMapProvider = this.stateSvc.getMapType();
		let now = this.playback.step;
		this.currentPoint = {
			speed: this.events[now].speed + " km/h",
			datetime: this.events[now].updated.format('DD-MM-YYYY HH:mm:ss'),
			status: this.events[now].event.replace('_', ' '),
			location: this.events[now].location
		};
		if(!this.listedVehicles || !this.events[now]) return;
		if(currentMapProvider == "Google"){
			this.vehicleMarker.setPosition({
				lat: this.events[now].lat,
				lng: this.events[now].lon,
			});
			this.tripInfowindow.forEach((idfw) => {
				// idfw.close();
			});
		}else{
			this.vehicleMarker.setLatLng([this.events[now].lat, this.events[now].lon]).update();
			this.tripInfowindow.forEach((idfw) => {
				// idfw.closePopup();
			});
		}
		if(this.tripInfowindow[now]) {
			if(currentMapProvider == "Google"){
				// this.tripInfowindow[now].open(this.map, this.tripMarkers[now]);
			}else{
				this.map.setView([this.events[now].lat, this.events[now].lon]);
				// this.tripInfowindow[now].openPopup();
			}
		}

	}
	
	runPlayback(st){
		this.playback.playing = st;
		if(!st){
			clearInterval(this.timeout);
			this.timeout = false;
		}else{
			this.timeout = setInterval(() => {
				if(!this.goFwd()) {
					this.playback.playing = false;
					clearInterval(this.timeout);
				}
			}, 1000);
		}
	}
	
	getMarkerImage(event) {
		var icon = event.event.toLowerCase();
		if(['hard_accel', 'hard_brake', 'time', 'speed'].indexOf(icon) > -1) {
			var bearing = parseInt(event.bearing, 10);
			var suff = '_n';
			if(bearing > 22.5 && bearing < 67.5) {
				suff = '_ne';
			}
			if(bearing > 67.5 && bearing < 112.5) {
				suff = '_e';
			}
			if(bearing > 112.5 && bearing < 157.5) {
				suff = '_se';
			}
			if(bearing > 157.5 && bearing < 202.5) {
				suff = '_s';
			}
			if(bearing > 202.5 && bearing < 247.5) {
				suff = '_sw';
			}
			if(bearing > 247.5 && bearing < 292.5) {
				suff = '_w';
			}
			if(bearing > 292.5 && bearing < 337.5) {
				suff = '_nw';
			}
			icon = icon + suff;
		}
		return 'assets/images/events_icon/' + icon + '.png';
	}
	
	onUserChangeEnd(changeContext: ChangeContext): void {
		this.minValue = changeContext.value;
		this.maxValue = changeContext.highValue;
		let range = [
			this.minValue,
			this.maxValue
		];
		this.vehicleSvc.setRangeTrips(range);
		this.fetchMovementEvents();
	}

	removeTripMarker(){
		let currentMapProvider = this.stateSvc.getMapType();
		if(currentMapProvider == "Google"){
			if(this.tripMarkers.length > 0){
				this.tripMarkers.forEach((mkr) => {
					mkr.setMap(null);
				});
			}
			this.storedDirectionsRenderer.setMap(null);
			this.tripMarkers = [];
			// vehicle marker
			if(this.vehicleMarker?.map){
				this.vehicleMarker.setMap(null);
			}
			this.vehicleMarker = {};
			// start end flag marker
			if(this.startEndFlagMarker.length > 0){
				this.startEndFlagMarker.forEach((mkr) => {
					mkr.setMap(null);
				});
			}
			this.startEndFlagMarker = [];
			if(this.tripPath.length > 0){
				this.tripPath.forEach((path) => {
					path.setMap(null);
				});
				this.tripPath = [];
			}
		}else{
			if(this.tripMarkers.length > 0){
				this.tripMarkers.forEach((mkr) => {
					mkr.remove();
				});
			}
			this.tripMarkers = [];
			// vehicle marker
			if(this.vehicleMarker?._latlng){
				this.vehicleMarker.remove();
			}
			this.vehicleMarker = {};
			// start end flag marker
			if(this.startEndFlagMarker.length > 0){
				this.startEndFlagMarker.forEach((mkr) => {
					mkr.remove();
				});
			}
			this.startEndFlagMarker = [];
			if(this.tripPath.length > 0){
				this.tripPath.forEach((path) => {
					path.remove();
				});
				this.tripPath = [];
			}
		}
	}

	onDateChange(){
		this.currentDate = moment(this.currentDateStr);
		this.currentDateChanged();
	}
	
	updateDateStr() {
		this.currentDateStr = this.currentDate.format('YYYY-MM-DD');
	}
	
	pushToCoordsArray(vlat, vlon){
		let currentMapProvider = this.stateSvc.getMapType();
		let foundSame = false;
		/*if(this.pathCoords.length > 0){
			let poin = this.pathCoords[this.pathCoords.length - 1];
			if(poin[0] == vlat && poin[1] == vlon){
				foundSame = true;
				return;
			}
		}*/
		if(!foundSame){
			let tmpArr = [vlat, vlon];
			if(currentMapProvider == "Google"){
				this.pathCoords.push(new google.maps.LatLng({
					lat: parseFloat(vlat),
					lng: parseFloat(vlon)
				}));
			}else{
				this.pathCoords.push([parseFloat(vlat),parseFloat(vlon)]);
			}
		}
	}
	
	callRoadApi(){
		let currentMapProvider = this.stateSvc.getMapType();
		if(currentMapProvider == "Google"){
			let snappedPolyline = new google.maps.Polyline({
				path: this.pathCoords,
				strokeColor: '#ff0000',
				strokeWeight: 4,
				strokeOpacity: 1.0,
			});

			snappedPolyline.setMap(this.map);
			this.tripPath.push(snappedPolyline);
		}else{
			// var linePoints = this.tripMarkers.map((marker:any) => marker.getLatLng());
			// let snappedPolyline = L.polyline(linePoints, {color: '#ff0000'}, smoothFactor: 2).addTo(this.map);
			let snappedPolyline = L.polyline(this.pathCoords, {color: '#ff0000', smoothFactor: 2}).addTo(this.map);
			this.tripPath.push(snappedPolyline);
		}
		/*this.gmapSvc.snappedData(this.pathCoords)
		.subscribe((data) => {
			console.log('res',data);
			
			let snappedCoordinates = [];
			let placeIdArray = [];
			for (let i = 0; i < data.snappedPoints.length; i++) {
				let latlng = new google.maps.LatLng(
					data.snappedPoints[i].location.latitude,
					data.snappedPoints[i].location.longitude);
				snappedCoordinates.push(latlng);
				placeIdArray.push(data.snappedPoints[i].placeId);
			}
			let snappedPolyline = new google.maps.Polyline({
				path: snappedCoordinates,
				strokeColor: '#ff0000',
				strokeWeight: 4,
				strokeOpacity: 1.0,
			});

			snappedPolyline.setMap(this.map);
			this.tripPath.push(snappedPolyline);
		});*/
		
	}

}
